import Swal from 'sweetalert2';

export const mostrarAlertaWarning = (
  mensaje: string = '',
  titulo: string = 'Atención'
): void => {
  Swal.fire({
    title: titulo,
    text: mensaje,
    icon: 'warning',
    confirmButtonColor: 'var(--bGreen-600)',
  });
};

export const mostrarAlertaError = (
  mensaje: string = '',
  titulo: string = 'Atención'
): void => {
  Swal.fire({
    title: titulo,
    text: mensaje,
    icon: 'error',
    confirmButtonColor: 'var(--bGreen-600)',
  });
};

export const mostrarAlertaSuccess = (
  mensaje: string = '',
  titulo: string = 'Atención'
): void => {
  Swal.fire({
    title: titulo,
    text: mensaje,
    icon: 'success',
    confirmButtonColor: 'var(--bGreen-600)',

  });
};
